import moment from "moment";
import { memo, useCallback } from "react";
import Select from "react-select";
import SearchDatePicker from "Shared/Common/DatePicker/SearchDatePicker";
import useLang from "Shared/hooks/useLanguage";
import DatePicker from "Shared/Common/DatePickerResultData/DatePicker";
import TimePicker from "Shared/Common/TimePickerResultData/TimePicker";
import { reactSelectSMStyle, styles } from "Utils/Common";
import { upsertArray } from "Utils/Common/Requisition";

const RenderInput = ({
  tabsDetail,
  currentColumnKey,
  setCurrentColumnKey,
  // tabValue,
  triggerFetch,
  setCurPage,
  filterData,
  setFilterData,
  searchValue,
  setSearchValue,
}: any) => {
  const { t } = useLang();

  const updateFilters = useCallback(
    (value: string) => {
      const filterObj = {
        columnName: tabsDetail.filterColumns,
        filterValue: value,
        columnType: tabsDetail.filterColumnsType,
        label: tabsDetail.columnLabel,
        columnKey: tabsDetail.columnKey,
      };

      const updatedFilters = upsertArray(
        filterData.filters,
        filterObj,
        (el: any) => el.columnName === filterObj.columnName
      ).filter((el: any) => el.filterValue !== "");

      setFilterData({ ...filterData, filters: updatedFilters });
    },
    [filterData, setFilterData, tabsDetail]
  );

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      setFilterData((prev: any) => ({ ...prev, pageNumber: 1 }));
      setCurPage(1);
      triggerFetch();
    }
  };

  const handleChange = (e: any) => {
    let value = e.target.value;
    if (e.target.type === "date") {
      value = moment(value, "YYYY-MM-DD").format("MM/DD/YYYY");
    }
    setSearchValue((prev: any) => ({
      ...prev,
      [tabsDetail.columnKey]: value,
    }));
    updateFilters(value);
  };

  const handleSelectChange = (e: any) => {
    const value = String(e.value);
    setSearchValue((prev: any) => ({
      ...prev,
      [tabsDetail.columnKey]: value,
    }));
    updateFilters(value);
  };

  return (
    <div>
      {tabsDetail.filterColumnsType === "text" && (
        <input
          id={`CreateBatchSearch_${tabsDetail.columnKey}`}
          type="text"
          autoComplete="off"
          className="form-control bg-white mb-lg-0 h-30px rounded-2 fs-8 w-100"
          placeholder={t("Search ...")}
          value={searchValue[tabsDetail.columnKey] ?? ""}
          onChange={handleChange}
          onKeyDown={handleKeyPress}
        />
      )}

      {tabsDetail.filterColumnsType === "dateRange" && (
        <DatePicker
          tabsDetail={tabsDetail}
          columnKey={tabsDetail.columnKey}
          currentColumnKey={currentColumnKey}
          setCurrentColumnKey={setCurrentColumnKey}
          lisType="ID"
        />
      )}

      {tabsDetail.filterColumnsType === "DatePicker" && (
        <SearchDatePicker
          value={searchValue[tabsDetail.columnKey]}
          onChange={handleChange}
        />
      )}

      {tabsDetail.filterColumnsType === "timeRange" && (
        <TimePicker
          columnKey={tabsDetail.filterColumns}
          tabsDetail={tabsDetail}
        />
      )}

      {tabsDetail.filterColumnsType === "dropdown" && (
        <Select
          inputId={`CreateBatchSearch_${tabsDetail.columnKey}`}
          menuPortalTarget={document.body}
          theme={(theme) => styles(theme)}
          placeholder={t("Select...")}
          onChange={handleSelectChange}
          isSearchable
          styles={reactSelectSMStyle}
          onKeyDown={handleKeyPress}
          options={[]}
          value={null}
        />
      )}
    </div>
  );
};

export default memo(RenderInput);
